export type DriverPassTypeSummary = {
  enabled: boolean;
  label: string;
};

export type DriverPassSummary = {
  el_abra: DriverPassTypeSummary;
  dmh: DriverPassTypeSummary;
  dgm: DriverPassTypeSummary;
};

export const DRIVER_PASS_SUMMARY_SHORT_LABELS: Record<keyof DriverPassSummary, string> = {
  el_abra: 'El Abra',
  dmh: 'DMH',
  dgm: 'DGM',
};

export function getPassSummaryTooltip(summary: DriverPassTypeSummary): string {
  return summary.enabled
    ? `${summary.label}: tiene pase activo`
    : `${summary.label}: sin pase`;
}
